// Progress-capable PUT/GET for encrypted file transfer. fetch() gives no
// upload-progress event, so XMLHttpRequest is the by-the-books way to drive
// a real upload/download bar.

export function putWithProgress(
  url: string,
  body: Uint8Array<ArrayBuffer>,
  onProgress: (fraction: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(e.loaded / e.total);
    };
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`upload ${xhr.status}`));
    xhr.onerror = () => reject(new Error('upload failed'));
    xhr.send(body);
  });
}

export function getWithProgress(
  url: string,
  onProgress: (fraction: number) => void,
): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'arraybuffer';
    xhr.onprogress = (e) => {
      if (e.lengthComputable) onProgress(e.loaded / e.total);
    };
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300
        ? resolve(xhr.response as ArrayBuffer)
        : reject(new Error(`download ${xhr.status}`));
    xhr.onerror = () => reject(new Error('download failed'));
    xhr.send();
  });
}
